import PropTypes from 'prop-types'
import React from 'react'

import SectionWrapper from 'components/SectionWrapper'
import { BoxBase, RowIndented } from 'styles/components/layout'
import { scrollToBlock } from 'utils/client/scroll'

import {
  ArrowBlock,
  ArrowWrapper,
  Button,
  StyledIcon,
  TitleBox,
  Title,
  ColStyled,
} from './styles'

/**
 * CartFillForm
 *
 * @param {object} props - properties of component
 * @returns {node} CartFillForm
 */
const CartFillForm = props => {
  const { title, formBlockRef } = props
  const handleScroll = () => {
    scrollToBlock(formBlockRef)
  }

  return (
    <SectionWrapper isWideToDesktop={true}>
      <BoxBase>
        <RowIndented indent={{ xs: 0, md: 0, lg: 0 }}>
          <ColStyled width={{ xs: 1, md: 11 / 12, lg: 10 / 12 }}>
            <Button
              className="link"
              onClick={handleScroll}
              onTouchEnd={handleScroll}
            >
              <TitleBox>
                <Title dangerouslySetInnerHTML={{ __html: title }} />
              </TitleBox>
              <ArrowWrapper>
                <ArrowBlock>
                  <StyledIcon
                    id="arrow_long_right"
                    color="black"
                    strokeWidth="1"
                  />
                </ArrowBlock>
              </ArrowWrapper>
            </Button>
          </ColStyled>
        </RowIndented>
      </BoxBase>
    </SectionWrapper>
  )
}

CartFillForm.propTypes = {
  /** Reference to block with form */
  formBlockRef: PropTypes.object.isRequired,

  /** Title of button */
  title: PropTypes.string.isRequired,
}

CartFillForm.defaultProps = {}

export default CartFillForm
